module.exports = __webpack_public_path__ + "assets/img/shop_detail_img6.46e26289.png";